export class Transactions {

}

export class SaleTransactionParams {
      NpiNo: any = null;
      PatientNo: any = null;
      Amount: any = null;
      TransId: any = null;
      TransactionItems!: TransactionItems[];
}
export class addSignatureParams {
       transID:any =null;
  npiNo:any = null;
  Signatures!: Signatures[];
}
export class SaleTransaction {
      Code: any = null;
      Message: any = null;
      TransID: any = null;
      TransactionSetupID: any = null;
      PaymentTransactionURL: any = null;

}
export class TransactionItems {
      RxNo: any = null;
      RefillNo: any = null;
      PartialFillNo: any = null;
      DrugName: any = null;
      Quantity: any = null;
      Amount: any = null;
}
export class Signatures {
      SignatureImageBase64:any =null;
      SignatureSource:any = null;
      SignatureType:any = null
      SignatureDtTm:any=null;
}

export class TransactionDetail {
      PharmacyNPI: string  = "";
      ApplicationId: number = 7; //For PatientEngagement App 
      PaymentProviderId:number = 1; //[Possible Value=>1=Vantiv/Worldpay, 2= Elavon, 3= HPSPAX]  
      primerxPayTransId: number = 0;
      ApplicationTransId: number = 0;
      TransSetupID: any  = null;
}

export class PendingPaymentModel  {
      version: string = "";
      responseCode: number =  0;
      timestamp: string = "";
      errorDescription: string = "";
      result: string = "";
      message: string = "";
      //data:  PendingPaymentDataModel  = {};
    }
export  class PendingPaymentDataModel {
      transID : string =  "";
      npiid: string =  "";
      userID : string =  "";
      status: string = "";
      transDate: string = "";
      transType: string = "";
      amount : number = 0;
}
export class SalesDetailsListModel {
      saleDetailID: string = "";
      taxID: string = "";
      taxPercentage: number = 0;
      itemID: string = "";
      itemDept: string = "";
      itemDeptName: string = "";
      itemDescription: string = "";
      qty: number = 0;
      price: number  = 0;
      discount: number = 0;
      discountAmount: number = 0;
      extendedPrice: number = 0;
      isGroupPrice: string = "";
      getItemCost: string = "";
      isIias: string = "";
      isMonitored: boolean = false;
      itemMonitoringCategoryId: string = "";
      isPSE: boolean = false;
      isEbt: boolean = false;
      returnTransDetailId: string = "";
      originalPrice: number = 0;
      isComboItem: string = "";
      loyaltyPoints: string = "";
      couponID: string = "";
      isNonRefundable : string = "";
      orgPOSTransID: string = "";
      orgProcessorTransID : string = "";
      returnProcessorTransID: string = "";
      invoiceDiscount : number = 0;
      excludeFromReceipt: boolean = false;
}
export class RxDetailsModel {
      rxno: string = "";
      drgname: string = "";
      ndc: string = "";
      qtY_ORD: string = "";
      quant: string = "";
      units: string = "";
      detdrgname: string = "";
      nrefill: string = "";
      partialFillNo: string = "";
      patientName: string = "";
      vrfstage: string = "";
      trefills: string = "";
      days: string = "";
      strong: string = "";
      pattype: string = "";
      billtype: string = "";
      status: string = "";
      presno : string = "";
      patamt: string = "";
      dateo: string = "";
      datef: string = "";
      siglines: string = "";
      form: string = "";
      class_: string = "";
      patientno: string = "";
      pickedup: string = "";
      pickupdate: string = "";
      pickuptime: string = "";
      pickupfrom: string = "";
      amount: string = "";
      copay: string = "";
      totamt: string = "";
      pfee: string = "";
      stax: string = "";
      discount: string = "";
      othfee: string = "";
      othamt: string = "";
      billedamt: string = "";
      unc: string = "";
      pickuppos: string = "";
      verified: string = "";
      bin: string = "";
      binStatus: string = "";
      familyID: string = "";
      delivery: string = "";
      isReturn:boolean =  true;
      drugclass:number =  0
}